import { Modal, ModalDialog, ModalClose } from "@mui/joy";
import React from "react";

type TImageViewModalProps = {
	open: boolean;
	onClose: () => void;
	imageUrl: string;
	altText?: string;
};

const ImageViewModal: React.FC<TImageViewModalProps> = ({
	open,
	onClose,
	imageUrl,
	altText,
}) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			sx={{ zIndex: 1605 }}
		>
			<ModalDialog
				sx={{
					width: "80vw",
					height: "80vh",
					margin: 0,
					padding: 1,
					display: "flex",
					flexDirection: "column",
					gap: 0.5,
					borderRadius: 0,
					zIndex: 1606,
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
					}}
				>
					<ModalClose
						sx={{
							position: "static",
							bgcolor: "rgba(255, 255, 255, 0.9)",
							color: "#374151",
							"&:hover": {
								bgcolor: "white",
							},
						}}
					/>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						overflow: "auto",
						flex: 1,
					}}
				>
					<img
						src={imageUrl}
						alt={altText ?? "Image"}
						style={{
							maxWidth: "100%",
							maxHeight: "calc(95vh - 80px)",
							width: "auto",
							height: "auto",
							objectFit: "contain",
						}}
					/>
				</div>
			</ModalDialog>
		</Modal>
	);
};

export default ImageViewModal;
